export enum CampusName {
    Vancouver = "Vancouver",
    Okanagan = "Okanagan"
}

export enum CampusCode {
    Vancouver = "V",
    Okanagan = "O"
}